import { render, staticRenderFns } from "./CardStudent.vue?vue&type=template&id=06750e60"
import script from "./CardStudent.vue?vue&type=script&lang=js"
export * from "./CardStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports